import { getDateParts } from './getDateParts';

/**
 * Same as ./getDateParts, but parses each numerical value into a number.
 */
export const getDatePartsAsNumbers = (
    dateStamp: Maybe<string>,
): DatePartsAsNumbers | null => {
    const datePartsAsStrings = getDateParts(dateStamp);

    if (datePartsAsStrings !== null) {
        return {
            year: parseInt(datePartsAsStrings.year, 10),
            month: parseInt(datePartsAsStrings.month, 10),
            monthName: datePartsAsStrings.monthName,
            day: parseInt(datePartsAsStrings.day, 10),
        };
    }

    return null;
};
